<p *ngIf="errorArray?.length" class="error">
  <span *ngFor="let error of errorArray"> {{ error.Value }} </span>
</p>
